import { AEMScenes } from './RenderTypes';

export type ABComponent = {
  optionsEncoded?: string;
  configUrl?: string;
  storefrontEndpoint?: AEMScenes;
  htmlContentUrl?: string;
};

export type ABComponentConfiguration = {
  componentA: ABComponent;
  componentB: ABComponent;
};
